export const stats = [
  { value: '+72', label: 'Units Ready' },
  { value: '+2,000', label: 'Coaches Satisfied' },
  { value: '5,000+', label: 'Hours Saved' },
  { value: '99%', label: 'Would Recommend It' },
]

export const differenceStats = [
  { value: '+70', label: 'Ready-to-Teach Units (U10 to Advanced)' },
  { value: '6', label: 'Complete Digital Volumes' },
  { value: '100%', label: 'Instantly Downloadable' },
]

export const beforeItems = [
  'Hours searching for drills on YouTube every single week',
  "Repetitive practices that don't actually improve court IQ",
  'No clear progression path from U12 to competitive levels',
  'Not knowing how to assess if a player is ready for the next level',
  'Unmotivated players who feel "stuck" doing the same warm-ups',
]

export const afterItems = [
  '5-minute review and your whole 2-hour session is set',
  'Ultra-visual diagrams for rotations, transitions, and defense',
  'Real-game tactical applications integrated into every drill',
  'Assessments, rubrics, and certificates ready to print',
  'Players competing with absolute confidence and tactical purpose',
]

export const recognizeItems: Array<{ icon: string; text: string }> = [
  {
    icon: 'frown',
    text: 'Arriving at the gym without knowing how to explain a complex 6-2 or 5-1 rotation',
  },
  {
    icon: 'moon',
    text: 'Spending your entire Sunday night sketching drills on napkins',
  },
  {
    icon: 'search',
    text: 'Struggling to find high-quality diagrams that players actually understand',
  },
  {
    icon: 'clipboard',
    text: 'No clear way to show parents or directors that players are actually improving',
  },
  {
    icon: 'trend',
    text: "Players falling behind because the drills aren't matched to their skill level",
  },
]

export const packItems: Array<{ icon: string; title: string; text: string }> = [
  {
    icon: 'library',
    title: '6 Level-Based Volumes (Discovery to Strategist)',
    text: 'A full curriculum from U10 fundamentals to high-level competitive mastery',
  },
  {
    icon: 'pencil',
    title: 'Step-by-Step Coaching Scripts',
    text: 'Teacher prompts that tell you exactly how to explain a skill or fix a mistake in seconds',
  },
  {
    icon: 'ruler',
    title: 'Ultra-Visual Skill Cards & 3D Diagrams',
    text: 'High-quality graphics that make transition movements and defensive base positioning simple',
  },
  {
    icon: 'chart',
    title: 'Assessments & Graduation Sheets',
    text: 'Complete evaluation tools to professionalize your club or school program',
  },
  {
    icon: 'clipboard',
    title: 'Practice Sheets & Trackers',
    text: 'Done-for-you logs to monitor player growth and team stats week by week',
  },
]

export const instantItems = [
  'The 6 complete digital volumes (Vol. 1: The Discovery to Vol. 6: The Strategist)',
  'Units by level: Beginner (⭐), Intermediate (⭐⭐), and Challenge (⭐⭐⭐)',
  'Visual lessons for every technical concept (passing, serving, setting, attacking, blocking)',
  'Coach scripts that tell you exactly what to say in every practice',
  'Printable certificates to celebrate player advancement',
]

export const previewPages: Array<{ title: string; image: string }> = [
  {
    title: 'Ready Position & The W Formation',
    image:
      'https://cdn.magicpatterns.com/uploads/8CeNVVdLLuM8RZpaZ8RU8Q/Captura-de-pantalla-2026-09-01-a-las-5.43.06_p._m..webp',
  },
  {
    title: 'Setter Mechanics — 3 Angles',
    image:
      'https://cdn.magicpatterns.com/uploads/f4WJX1bd9QvyD3rUoHokEF/Captura-de-pantalla-2026-09-01-a-las-5.44.01_p._m..webp',
  },
  {
    title: 'Bad Pass Scenarios',
    image:
      'https://cdn.magicpatterns.com/uploads/2jhtAbhmFh7uU9FVT9KtYm/Captura-de-pantalla-2026-09-01-a-las-5.45.56_p._m..webp',
  },
  {
    title: '3 Back-Row Attack Options',
    image:
      'https://cdn.magicpatterns.com/uploads/riq3eetVNiUEjVPXV32viL/Captura_de_pantalla_2026-09-01_a_las_5.48.54_p.webp',
  },
  {
    title: 'Key Pressure Plays',
    image:
      'https://cdn.magicpatterns.com/uploads/ibkVSKkNGaatj8bYBtvWTi/Captura_de_pantalla_2026-09-01_a_las_5.49.50_p.webp',
  },
  {
    title: 'Mastermind Network Planning Guide',
    image:
      'https://cdn.magicpatterns.com/uploads/ayYfRyVuuPZRtZB8vMTWau/Captura_de_pantalla_2026-09-01_a_las_5.50.47_p.webp',
  },
]

export const bonuses = [
  {
    title: 'The 5-Minute Practice Fix™',
    was: '$27',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/aaa00d89-7c5a-46da-aff1-1bdaa35685f1.jpg',
  },
  {
    title: 'Chaos-Proof Drills™ (20 Emergency Drills)',
    was: '$47',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/b742d162-8c60-45f0-841a-dd3fb094a5af.jpg',
  },
  {
    title: 'Parent Shield™ (Communication Vault)',
    was: '$36',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/2f8f9d3a-27be-4fb5-a71b-14eaf6c9edf1.jpg',
  },
  {
    title: 'Win the First Set™ (Opponent Read System)',
    was: '$19',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/8352526a-d7e0-4318-81d6-1bcdd7ad84e6.jpg',
  },
  {
    title: 'Player Progress Map™ (Visual Tracker)',
    was: '$19',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/b7a21c35-3b3d-42e1-9e71-a5f9ae75c753.jpg',
  },
]

export const offerRows = [
  { label: 'Volleyball Ready™ Pack (6 Digital Volumes)', value: '$77' },
  { label: '5 Exclusive Strategic Bonuses', value: '$148' },
]

export const testimonials = [
  {
    quote:
      'I have my Sundays back. The progression from U12 to U16 is exactly what I needed for my club.',
    name: 'Mark S.',
    location: 'USA',
  },
  {
    quote:
      'The visual transition maps make a huge difference. Players finally understand where to move on defense.',
    name: 'Liam D.',
    location: 'UK',
  },
  {
    quote:
      'Finally, a professional volleyball resource that is actually visual and ready to print. Worth every penny.',
    name: 'David L.',
    location: 'Australia',
  },
]

export const faqs = [
  {
    q: 'How do I receive the material?',
    a: "Instantly. After payment, you'll get a PDF download link in your email to access every volume and printable.",
  },
  {
    q: 'Does this work for beginner coaches?',
    a: 'Yes. The scripts tell you exactly what to say and do in the gym, so you build authority from your first practice.',
  },
  {
    q: 'What skill levels does this cover?',
    a: 'Everything from U10 fundamentals to College-Prep, with drills and assessments mapped to each level.',
  },
  {
    q: 'Are the bonuses included?',
    a: 'Yes, all 5 strategic bonuses are included for life if you buy during the launch offer.',
  },
  {
    q: 'Is there a monthly fee?',
    a: 'No. This is a one-time payment for lifetime access. No hidden fees or subscriptions.',
  },
]
